import _ from 'lodash'
import config from '../../config.js';
import products from '../../utils/products.js';
import fast_food_schema from './schema.step.fresh_web_fast_food.js'
import fieldUtils from '../../utils/step.fields.utils.js';

const ffSchema = _.cloneDeep(fast_food_schema)
const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`
        },
    ];
};
const drivers = (n) => {
    const result = [
        {...fieldUtils.driver_x_name(n)},
        {...fieldUtils.driver_x_date_of_birth(n)},
        {...fieldUtils.driver_x_licence_type(n)},
        {...fieldUtils.driver_x_licence_date(n)},
    ];

    if (n < config[products.courier].drivers) {
        result.push({
            ...fieldUtils.driver_x_more(n),
            children: drivers(n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};
const claims = (driver, n) => {
    const result = [
        {...fieldUtils.claim_x_type(driver, n)},
        {...fieldUtils.claim_x_date(driver, n)},
    ];

    if (n < config[products.courier].claims) {
        result.push({
            ...fieldUtils.claim_x_more(driver, n),
            children: claims(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};
const convictions = (driver, n) => {
    const result = [{
        ...fieldUtils.conviction_x_type(driver, n),
    }];

    if (n < config[products.courier].mot_convictions) {
        result.push({
            ...fieldUtils.conviction_x_more(driver, n),
            children: convictions(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};
const base_schema = [
    {
        key: 'vrm',
        type: 'vehicle-lookup-step',
        placeholder: 'Registration Number',
    },
    {
        key: 'make',
        required: true,
        skip_question: true,
    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        skip_question: true,
    },
    {
        key: 'body_type'
    },
    {
        key: 'owner'
    },
    {
        key: 'ncb_years_private'
    },
    {
        key: 'ncb_years_courier'
    },
    {
        key: 'weight_over_35'
    },
    {
        key: 'value',
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true
    },
    {
        key: 'address3',
        skip_question: true
    },
    {
        key: 'address4',
        skip_question: true
    },
    {
        key: 'city',
        skip_question: true
    },
    {
        key: 'uk_since',
        children: [
            {
                key: 'uk_since_date',
                required_if: parent_value => parent_value === false
            },
        ],
    },
    {
        key: 'licence_type',
    },
    {
        key: 'licence_date',
    },
    {
        key: 'occupation_0_type',
        value: 'courier'
    },
    {
        key: 'occupation_0_more',
        children: secondOccupation(),
        required_children: value => value === true,
    },
    {
        key: 'has_convictions_more',
        children: convictions('Proposer\'s', 0),
        required_children: value => value === true,
    },
    {
        key: 'has_claims_more',
        children: claims('Proposer\'s', 0),
        required_children: value => value === true
    },
    {
        key: 'has_another_driver_more',
        children: drivers(0),
        required_children: value => value === true,
    },
    //policy
    {
        key: 'cover_date'
    },
    {
        key: 'previous_policy_cancelled'
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
]

const getChildren = (value = '') => {
    if (value === 'food') {
        return ffSchema
    }
    return base_schema
}
const step_schema_courier = [
    {
        key: 'shipment',
        orderOptions: false,
        children: getChildren
    }
];

export default step_schema_courier;
